export default "__VITE_ASSET__CtpG_EHD__"